import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import ImageSubCategoryList from '../imageSubCategoryList'
import { LinkGroupProps } from '../SubCategoryList'
import * as subCategoryListStyles from '../subCategoryList.module.scss'
import TextSubCategoryList from '../textSubCategoryList'

export interface SubCategoryLinksListProps {
  // buttonGroup: Omit<ButtonGroupProps, 'sendEventOnButtonClick'>
  linkGroup: LinkGroupProps
}

const SubCategoryLinksList = ({ linkGroup }: SubCategoryLinksListProps) => {
  const sendEventOnButtonClick = (filterUsed: string, buttons: any) => {
    trackEvent(TELEMETRY_EVENT_NAMES.SIMILAR_COLLECTION_CLICKED, {
      filter_count: buttons?.length || 0,
      filter_used: filterUsed,
      filter_available: buttons?.map(button => button?.name || button?.children),
    })
  }
  return (
    <>
      <ImageSubCategoryList
        {...linkGroup}
        sendEventOnButtonClick={sendEventOnButtonClick}
        className={subCategoryListStyles.imageSubCategory}
      />
      <TextSubCategoryList
        {...linkGroup}
        sendEventOnButtonClick={sendEventOnButtonClick}
        className={subCategoryListStyles.textSubCategory}
      />
      {/* <ButtonGroup
        {...buttonGroup}
        sendEventOnButtonClick={sendEventOnButtonClick}
        className={subCategoryListStyles.container__buttons}
      /> */}
    </>
  )
}

export default SubCategoryLinksList
